var map = {
	"./Marketing_Online.svg": "./assets/images/advisory/Marketing_Online.svg",
	"./So_Huu_Tri_Tue.svg": "./assets/images/advisory/So_Huu_Tri_Tue.svg",
	"./Thiet_Ke_Bao_Bi.svg": "./assets/images/advisory/Thiet_Ke_Bao_Bi.svg",
	"./Tu_Van_Phap_Ly_Doanh_Nghiep.svg": "./assets/images/advisory/Tu_Van_Phap_Ly_Doanh_Nghiep.svg",
	"./Tu_Van_Phap_Ly_San_Pham.svg": "./assets/images/advisory/Tu_Van_Phap_Ly_San_Pham.svg",
	"./Xay_Dung_Website.svg": "./assets/images/advisory/Xay_Dung_Website.svg",
	"./phone.png": "./assets/images/advisory/phone.png",
	"./skype.png": "./assets/images/advisory/skype.png",
	"./zalo.png": "./assets/images/advisory/zalo.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/advisory recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory ^\.\/.*$
// module id = ./assets/images/advisory recursive ^\.\/.*$
// module chunks = 0